<script setup lang="ts">
import { storeToRefs } from 'pinia'
import ResourceCard from '@/resources/ResourceCard.vue'
import { usePresentLevelsWizardStore } from '@/presentlevels/no-ai/present_levels_wizard.store'

const { resourceDocs } = storeToRefs(usePresentLevelsWizardStore())
</script>

<template>
  <ul class="m-0 list-none p-0 lg:w-9/12 xl:w-8/12">
    <li v-for="resource in resourceDocs" :key="resource.uuid">
      <ResourceCard
        :uuid="resource.uuid"
        :title="resource.title"
        :num_pages="resource.num_pages"
        :description="resource.description"
        :type="resource.type"
        :screenshots="resource.screenshots"
        :thumbnail_url="resource.thumbnail_url"
        :grades="resource.grades"
        :subjects="resource.subjects"
        :download_links="resource.download_links"
        :google_drive_links="resource.google_drive_links"
        :language="resource.language"
        :heading-level="3"
      />
    </li>
  </ul>
</template>
